import { render, staticRenderFns } from "./headerV1.vue?vue&type=template&id=beba2856&scoped=true&"
import script from "./headerV1.vue?vue&type=script&lang=js&"
export * from "./headerV1.vue?vue&type=script&lang=js&"
import style0 from "./headerV1.vue?vue&type=style&index=0&id=beba2856&lang=scss&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beba2856",
  null
  
)

export default component.exports